import * as PIXI from "pixi.js";
import {BaseButton} from "../Core/Button";
import {ISignal} from "../Core/Signal";

export interface IDraggable {
    readonly onStartDrag?: ISignal<(event: PIXI.InteractionEvent) => void>;
    readonly onStopDrag?: ISignal<(event: PIXI.InteractionEvent) => void>;
    readonly onDrag?: ISignal<() => void>;
    readonly onVirtualDrag?: ISignal<(data: PIXI.InteractionData) => void>;
    readonly draggable: boolean;
}

export function Draggable(this: BaseButton & IDraggable) {
    const point = {x: 0, y: 0};
    let data: PIXI.InteractionData;
    const onMove = () => {
        if (this.draggable === undefined || this.draggable) {
            const p = data.getLocalPosition(this.parent);
            this.x = p.x - point.x;
            this.y = p.y - point.y;
            if (this.onDrag) this.onDrag();
        } else {
            if (this.onVirtualDrag) this.onVirtualDrag(data);
        }
    };
    const onUp = (e: PIXI.InteractionEvent) => {
        this.off("pointermove", onMove);
        this.off("pointerup", onUp);
        this.off("pointerupoutside", onUp);
        if (this.onStopDrag) this.onStopDrag(e);
    }
    this.onDown.add((b, e) => {
        if (!e) return;
        data = e.data;
        const p = data.getLocalPosition(this.parent);
        point.x = p.x - this.x;
        point.y = p.y - this.y;
        this.off("pointermove", onMove);
        this.off("pointerup", onUp);
        this.off("pointerupoutside", onUp);
        this.on("pointermove", onMove);
        this.on("pointerup", onUp);
        this.on("pointerupoutside", onUp);
        if (this.onStartDrag) this.onStartDrag(e!);
    });
    const destroy = this.destroy;
    this.destroy = () => {
        this.onStartDrag?.remove();
        this.onStopDrag?.remove();
        this.onDrag?.remove();
        this.onVirtualDrag?.remove();
        destroy.call(this);
    };
    return this;
}
